import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component';
import { environment } from 'environments/environment';
@Injectable()
export class StaffSearchService extends ServiceBase {

    constructor(private _http: HttpClient) {
        super();
    }

    getStaffByRole = (filter: any): Observable<any> => {

        return this._http.post<any>(`${environment.queryModel}Staff/StaffByRole`, filter, { responseType: 'silent' as 'json' });
    }
}